import { render, staticRenderFns } from "./chargeRate.vue?vue&type=template&id=4fa21ce2&"
import script from "./chargeRate.vue?vue&type=script&lang=js&"
export * from "./chargeRate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4fa21ce2')) {
      api.createRecord('4fa21ce2', component.options)
    } else {
      api.reload('4fa21ce2', component.options)
    }
    module.hot.accept("./chargeRate.vue?vue&type=template&id=4fa21ce2&", function () {
      api.rerender('4fa21ce2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Information/chargeRate.vue"
export default component.exports